import React, { useEffect, useState } from 'react';
import { getdatanoauth, getdata } from "../../util/global";

const IntakeFormView = () => {
  const params = new URLSearchParams(window.location.search);
  const intakeformid = params.get('intakeformid');
  const [formdata, setformdata] = useState<any>(null);

  const fetchdata = async () => {
    if (!intakeformid) return;
    try {
      const res = await getdata({ 
        filter: { _id: intakeformid, datatype: "intakeformdata" } 
      });
      if (res && res.length > 0) setformdata(res[0]);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchdata();
  }, [intakeformid]);

  const handleprint = () => {
    const content = document.getElementById('printviewarea')?.innerHTML;
    if (!content) return;

    const frame = document.createElement('iframe');
    frame.style.display = 'none';
    document.body.appendChild(frame);
    const win = frame.contentWindow;
    if (!win) return;

    win.document.write('<html><head><title>Intake Form</title>');
    win.document.write(`<base href="${window.location.origin}">`);
    win.document.write(`
      <style>
        * { box-sizing: border-box; font-family: sans-serif; }
        body { margin: 0; padding: 10px; font-size: 12px; color: #333; }
        hr { border: none; border-top: 1px solid #eee; margin: 15px 0; }
        .print-img { display: block; width: 100%; height: auto; max-height: 140px; object-fit: contain; margin: 0 auto; }
        .demographics { display: flex; flex-wrap: wrap; gap: 15px; background: #f9f9f9; padding: 10px; border-radius: 4px; margin: 15px 0 25px 0; }
        .demographics div { flex: 1; min-width: 120px; }
        .questionrow { margin-bottom: 15px; page-break-inside: avoid; }
        .questionlabel { font-weight: 600; margin-bottom: 4px; }
        .answerbox { padding: 6px; background: #fcfcfc; border-left: 3px solid #007bff; }
      </style>
    `);
    win.document.write('</head><body>');
    win.document.write(content);
    win.document.write('</body></html>');
    win.document.close();

    setTimeout(() => {
      win.print();
      document.body.removeChild(frame);
    }, 300);
  };

  if (!formdata) return <div style={{ padding: '20px' }}>No intake form entry found.</div>;

  const headerimg = "/css/appointment/prescription-header.png";
  const footerimg = "/css/appointment/prescription-footer.png";

  const getval = (id: string) => formdata.responses?.find((r: any) => r.questionid === id)?.answer || 'N/A';

  return (
    <div className="modal-overlay" style={{ padding: '20px' }}>
      <div className="modal-content" style={{ width: '600px', margin: '0 auto', background: '#fff', padding: '20px', borderRadius: '8px' }}>
        
        <div id="printviewarea" style={{ padding: '20px', height:'300px', overflow:'auto', border: '1px solid #ccc' }}>

          {/* Header Image */}
          <img src={headerimg} alt="Header" className="print-img" style={{ display: 'block', width: '100%', height: 'auto', maxHeight: '140px', objectFit: 'contain', marginBottom: '15px' }} />

          {/* Demographic Summary Blocks */}
          <div className="demographics" style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', background: '#f9f9f9', padding: '10px', borderRadius: '4px', marginBottom: '25px', fontSize: '11px' }}>
            <div><strong>Patient Name:</strong> {getval('name')}</div>
            <div><strong>Phone Number:</strong> {getval('phone')}</div>
            <div><strong>Age:</strong> {getval('age')}</div>
            <div><strong>Sex:</strong> {getval('sex')}</div>
          </div>

          {/* Question and Answer Stack Lineups */}
          <div style={{ paddingRight: '5px' }}>
            {formdata.responses?.map((q: any) => (
              <div key={q.questionid} className="questionrow" style={{ marginBottom: '15px' }}>
                <div className="questionlabel" style={{ fontWeight: 600, marginBottom: '4px', fontSize: '11px' }}>{q.question}</div>
                <div className="answerbox" style={{ padding: '6px', background: '#fcfcfc', borderLeft: '3px solid #007bff', fontSize: '11px' }}>
                  {q.answer || <span style={{ color: '#aaa' }}>— empty —</span>}
                </div>
              </div>
            ))}
          </div>

          {/* Footer Image */}
          <img src={footerimg} alt="Footer" className="print-img" style={{ display: 'block', width: '100%', height: 'auto', maxHeight: '140px', objectFit: 'contain', marginTop: '25px' }} />
        </div>

        <hr style={{ margin: '15px 0', border: 'none', borderTop: '1px solid #eee' }} />
        
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <a href="#" onClick={(e) => { e.preventDefault(); handleprint(); }} style={{ fontSize: '13px', fontWeight: 600, color: '#007bff', textDecoration: 'none' }}>
            Print Intake Form
          </a>
        </div>

      </div>
    </div>
  );
};

export default IntakeFormView;